/**
 * @Author: junchao
 * @Date: 2022-04-26 17:41:29
 * @Description:
 */

import React, { useEffect, useMemo, useState } from 'react';
import Clipboard from '@umu/umu-clipboard';
import { Toast } from './toast';
import './index.scss';

export interface IProps {
    /** 需要复制的值 */
    clipValue: string;
    /** 复制按钮的文案 */
    buttonLabel: string | JSX.Element;
    className?: string;
    /** 复制成功后的提示文案 */
    successToast?: string;
    /** 复制失败后的提示文案 */
    failToast?: string;
    children?: JSX.Element;
    // 获取clipboard实例
    autoTriggerCopyHook?: any
}

export const ClipBoardButton = (props: IProps) => {
    const { buttonLabel, clipValue, className, successToast, failToast, children } = props;
    const [isSupported, setIsSupported] = useState(false);
    const btnClassName = useMemo(() => `j_do-clip-${className}-${Date.now()}`, []);
    useEffect(() => {
        const canDo = Clipboard.isSupported();
        setIsSupported(canDo);
        if (canDo) {
            const clipboard = new Clipboard(`.${btnClassName}`);
            clipboard.on('success', () => {
                Toast.show({
                    message: successToast || 'copy success',
                    duration: 1500,
                });
            });
            clipboard.on('error', () => {
                Toast.show({
                    message: failToast || 'copy fail',
                });
            });
        }
    }, []);

    return (
        <div className={`clipboardButton ${btnClassName}`} data-clipboard-text={clipValue}>
            {children}
            {isSupported ? <label>{buttonLabel}</label> : null}
        </div>
    );
};
